import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

import Vant from 'vant';
import 'vant/lib/index.css';
import Element from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css';
import './assets/moreFonticon/iconfont.css';

Vue.use(Element)
Vue.use(Vant);

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')

if (process.env.VUE_APP_BASE_API !== 'development') { // process是Node环境全部变量, 运行时根据敲击的命令不同, 脚手架会取环境变量给env添加属性和值
    console.log = function () {}
    console.error = function(){}
    console.dir = function(){}
}